import { CountryPickerProps } from '@design-system/country-picker';
import { TCountryCode } from 'countries-list';

import { iconMapper } from '../common';
import { CountryPicker } from './models';

export const countryPickerMapper = (
  countryPicker: CountryPicker[] | CountryPicker | null
): CountryPickerProps | undefined => {
  if (!countryPicker || (Array.isArray(countryPicker) && !countryPicker[0]))
    return undefined;

  const {
    openIcon,
    closeIcon,
    currentCountry,
    ariaLabel,
    buttonLabel,
    country: countries,
  } = countryPicker[0] || countryPicker;

  return {
    currentCountry: currentCountry.toUpperCase() as TCountryCode,
    ariaLabel,
    buttonLabel,
    closeIcon: { props: iconMapper(closeIcon[0]) },
    openIcon: { props: iconMapper(openIcon[0]) },
    country: countries.map((country) => ({
      url: country.url,
      countryCode: country.countryCode.toUpperCase() as TCountryCode,
      ariaLabel: country.ariaLabel,
    })),
  };
};
